import * as Yup from "yup";
import moment from "moment";

export const paymentPlanValidationSchema = Yup.object().shape({
  productName: Yup.string().required("Product name is required"),
  productPrice: Yup.number()
    .required("Product price is required")
    .positive("Product price must be positive"),
  customerEmail: Yup.string()
    .email("Invalid email")
    .required("Customer email is required"),
  numberOfWeeks: Yup.number()
    .required("Number of weeks is required")
    .min(2, "Number of weeks must be at least 2")
    .max(20, "Number of weeks must be no more than 20")
    .test(
      "is-even",
      "Number of weeks must be an even number",
      (value) => typeof value === "number" && value % 2 === 0
    )
    .test(
      "last-payment-before-departure",
      "Final payment must be at least 2 weeks before the departure date",
      function (numberOfWeeks) {
        const { departureDate } = this.parent;
        if (!departureDate || !numberOfWeeks) return true; // Skip if not both present

        const lastPaymentDate = moment()
          .add(numberOfWeeks, "weeks")
          .startOf("day");
        const deadline = moment(departureDate)
          .subtract(2, "weeks")
          .startOf("day");

        return lastPaymentDate.isSameOrBefore(deadline);
      }
    ),
  depositAmount: Yup.number()
    .required("Deposit amount is required")
    .positive("Deposit amount must be positive")
    .test(
      "deposit-less-than-price",
      "Deposit amount must be less than product price",
      function (value) {
        return value <= this.parent.productPrice;
      }
    ),
  departureDate: Yup.date()
    .required("Departure date is required")
    .min(
      moment().startOf("day").add(4, "weeks").toDate(),
      "Departure date must be at least 4 weeks from now"
    ),
  currency: Yup.string()
    .required()
    .matches(/^(aud|nzd|lkr)$/, "Currency must be either aud, nzd, or lkr"),
});